import { initializeApp } from "firebase/app";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

import config from "../util/config.json";
import { createContext, useContext, useEffect, useState } from "react";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import {
	FirebaseProviderData,
	MapEmulators,
} from "../types/providers/firebaseProviderData";

export const FirebaseContext = createContext<FirebaseProviderData>(
	{} as FirebaseProviderData
);

export const FirebaseProvider = ({
	children,
}: {
	children: JSX.Element;
}): JSX.Element => {
	const [usingEmulators, setUsingEmulators] = useState(false);
	const [emulatorsConfig, setEmulatorsConfig] = useState({} as MapEmulators);
	const myApp = initializeApp(config);
	const myAuth = getAuth(myApp);
	const myFS = getFirestore(myApp);
	const myFunctions = getFunctions(myApp);
	useEffect(() => {
		const shouldUseEmulator =
			process.env.REACT_APP_USING_EMULATOR === "TRUE" ? true : false;

		if (shouldUseEmulator) {
			let mapEmulators: MapEmulators = {} as MapEmulators;

			let FS_HOST = "localhost";
			let FS_PORT = 8088;

			if (FS_HOST && FS_PORT) {
				connectFirestoreEmulator(myFS, FS_HOST, FS_PORT);
				console.log(`firestore().useEmulator(${FS_HOST}, ${FS_PORT})`);
				mapEmulators.FS_HOST = FS_HOST;
				mapEmulators.FS_PORT = FS_PORT;
			}

			let AUTH_HOST = "localhost";
			let AUTH_PORT = 9099;
			if (AUTH_HOST && AUTH_PORT) {
				let AUTH_URL = `http://${AUTH_HOST}:${AUTH_PORT}`;
				console.log(
					`connectAuthEmulator(${AUTH_URL}, {disableWarnings: true})`
				);
				connectAuthEmulator(myAuth, AUTH_URL, {
					disableWarnings: true,
				});

				mapEmulators.AUTH_HOST = AUTH_HOST;
				mapEmulators.AUTH_PORT = AUTH_PORT;
				mapEmulators.AUTH_URL = AUTH_URL;
			}

			setUsingEmulators(true);
			setEmulatorsConfig(mapEmulators);

			console.log(
				"FIREBASE STARTUP: using Firebase emulator:",
				JSON.stringify(mapEmulators, null, 2)
			);
		}
	}, [myAuth, myFS]);

	const firebaseContextData: FirebaseProviderData = {
		usingEmulators,
		emulatorsConfig,
		myApp,
		myAuth,
		myFS,
		myFunctions,
	};
	return (
		<FirebaseContext.Provider value={firebaseContextData}>
			{children}
		</FirebaseContext.Provider>
	);
};

export const useFirebase = () => useContext(FirebaseContext);
